<template>
    <div>
        <div v-for="quality in qualities"
             v-if="propertyTypeModel === 'property_type-' + quality.id"
             class="row"
        >
            <div class="col-12">
                <div class="form-group mb-2">
                    <label class="required">{{ $t('parameters.form.names.construction_quality') }}</label>
                    <div class="custom-radio-lg custom-radio-lg--inline mb-0">
                        <div v-for="qualityValue in quality.values"
                             class="custom-control custom-radio custom-checkbox-lg__item"
                        >
                            <input type="radio" :id="'reproduction-quality_' + quality.id + '_' + qualityValue.id"
                                   name="coef_quality"
                                   v-model="reproductionQualityModel"
                                   :value="'reproduction-quality_' + quality.id + '_' + qualityValue.id"
                                   class="custom-control-input"
                                   :checked="reproductionQualityModel === 'reproduction-quality_' + quality.id + '_' + qualityValue.id"
                            >
                            <label class="custom-control-label"
                                   :for="'reproduction-quality_' + quality.id + '_' + qualityValue.id"
                            >
                                {{ $t('parameters.form.construction_quality.' + qualityValue.id) }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12">
                <div v-for="qualityValue in quality.values"
                     v-if="reproductionQualityModel === 'reproduction-quality_' + quality.id + '_' + qualityValue.id"
                >
                    <p v-html="$t('parameters.form.construction_quality.help.' + qualityValue.id)"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'reproductionQuality',
    props: {
        propertyTypeModel: {
            type: String,
            required: true,
        },
        oldQuality: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            reproductionQualityModel: 'reproduction-quality_family_house_standard',
            qualities: [
                {
                    id: 'apartment_house',
                    values: [
                        {
                            id: 'standard',
                            name: 'Standard',
                            help: 'Obsahuje základní prvky, <strong>žádné nadstandardní vybavení</strong>. Běžné materiály, klasické vybavení (1x koupelna a WC), klasický typ omítané fasády se zateplením. Střecha skládaná z tašek (keramické, betonové) nebo plechová.',
                        },
                        {
                            id: 'low',
                            name: 'Nízký',
                            help: 'Použité materiály a vybavení stavby <strong>jsou nízké kvality</strong>. Stavba neobsahuje prvky, které jsou popsány v standardním materiálovém vybavení. Nízký standard materiálu lze poznat při vizuální prohlídce. Souvisí s kvalitou materiálů a kvalitou provedení (větší množství nedodělků, reklamací a chyb). Dále obsahuje prvky, které brání k <strong>bezproblémovému užívání stavby</strong> (zbytečné schodky a překážky, stísněné prostory, nesmyslně řešená dispozice). Sociální zařízení (WC, koupelna) je sdílené pro více bytových jednotek.',
                        },
                        {
                            id: 'high',
                            name: 'Vysoký',
                            help: '<strong>Obsahuje některé z těchto prvků</strong>: balkon, lodžie, terasa, komora, sklepní kóje, prádelna, společné prostory. WC nebo koupelna jsou zde více jak jednou (např. 2x WC a obsahuje sprchu a vanu). Použitý <strong>materiál je nadstandardní kvality</strong> (velkoformátové obklady, designové vypínače/zásuvky, velkoformátová okna, střešní krytina z PVC folie).',
                        },
                        {
                            id: 'very_high',
                            name: 'Velmi vysoký',
                            help: '<strong>Obsahuje některé prvky z předchozího standardu a navíc některý z těchto prvků</strong>: krb, sauna, bazén, centrální vysavač, podlahové topení, klimatizace, elektrické žaluzie a rolety, obklady a ozdobné prvky (kamenné obklady, pohledový beton, nerezové prvky, mozaiky, dřevěné parkety). Dále obsahuje externí vybavení objektu: solární panely, nádrže na hospodaření s dešťovou vodou, provětrávané fasády (zelené, plechové, dřevěné), střechu (zelená, měděná, šindel, břidlice, pochozí, posuvná). ',
                        },
                    ],
                },
                {
                    id: 'family_house',
                    values: [
                        {
                            id: 'standard',
                            name: 'Standard',
                            help: 'Obsahuje základní prvky, <strong>žádné nadstandardní vybavení</strong>. Běžné materiály, klasické vybavení (1x koupelna a WC), klasický typ omítané fasády se zateplením. Střecha skládaná z tašek (keramické, betonové) nebo plechová.',
                        },
                        {
                            id: 'low',
                            name: 'Nízký',
                            help: 'Použité materiály a vybavení stavby <strong>jsou nízké kvality</strong>. Stavba neobsahuje prvky, které jsou popsány v standardním materiálovém vybavení. Nízký standard materiálu lze poznat při vizuální prohlídce, souvisí s kvalitou materiálů a kvalitou provedení (větší množství nedodělků, reklamací a chyb). Dále obsahuje prvky, které <strong>brání k bezproblémovému užívání stavby</strong> (zbytečné schodky a překážky, stísněné prostory, nesmyslně řešená dispozice).',
                        },
                        {
                            id: 'high',
                            name: 'Vysoký',
                            help: '<strong>Obsahuje některé z těchto prvků</strong>: balkon, lodžie, terasa, komora, nebo sklep. WC nebo koupelna jsou zde více jak jednou (např. v každém patře). Součástí domu je technická místnost (kotel, pračka, sušárna). Použitý <strong>materiál je nadstandardní kvality</strong> (velkoformátové obklady, designové vypínače/zásuvky, dřevěné parkety, velkoformátová okna).',
                        },
                        {
                            id: 'very_high',
                            name: 'Velmi vysoký',
                            help: '<strong>Obsahuje některé prvky z předchozího standardu a navíc některý z těchto prvků</strong>: krb, sauna, bazén, centrální vysavač, podlahové topení, klimatizace, elektrické žaluzie a rolety, obklady a ozdobné prvky (kamenné obklady, pohledový beton, nerezové prvky, mozaiky), solární panely, nádrže na hospodaření s dešťovou vodou, provětrávané fasády (zelené, plechové, dřevěné), střecha (zelená, měděná, šindel, břidlice, pochozí, posuvná).',
                        },
                    ],
                },
                {
                    id: 'recreational',
                    values: [
                        {
                            id: 'standard',
                            name: 'Standard',
                            help: 'Obsahuje základní prvky, <strong>žádné nadstandardní vybavení</strong>. Běžné materiály, klasické vybavení (1x koupelna a WC), klasický typ omítané fasády se zateplením. Střecha skládaná z tašek (keramické, betonové) nebo plechová.',
                        },
                        {
                            id: 'low',
                            name: 'Nízký',
                            help: 'Použité materiály a vybavení stavby <strong>jsou nízké kvality</strong>. Stavba neobsahuje prvky, které jsou popsány v standardním materiálovém vybavení. Nízký standard materiálu lze poznat při vizuální prohlídce. Souvisí s kvalitou materiálů a kvalitou provedení (větší množství nedodělků, reklamací a chyb). Dále obsahuje prvky, které <strong>brání k bezproblémovému užívání stavby</strong> (zbytečné schodky a překážky, stísněné prostory, nesmyslně řešená dispozice). Neobsahuje kompletní sociální zařízení (WC, koupelna). Chybí napojení na inženýrské sítě (voda, elektřina, plyn).',
                        },
                        {
                            id: 'high',
                            name: 'Vysoký',
                            help: '<strong>Obsahuje některé z těchto prvků</strong>: balkon, lodžie, terasa, komora, sklep, prádelna, skladovací prostory. WC nebo koupelna jsou zde více jak jednou (např. 2x WC a obsahuje sprchu a vanu). Součástí je technická místnost (kotel, pračka, sušárna) a systém ústředního topení. Použitý <strong>materiál je nadstandardní kvality</strong>  (velkoformátové obklady, dřevěné obklady, designové vypínače/zásuvky, velkoformátová okna).',
                        },
                        {
                            id: 'very_high',
                            name: 'Velmi vysoký',
                            help: '<strong>Obsahuje některé prvky z předchozího standardu a navíc některý z těchto prvků</strong>: krb, sauna, bazén, centrální vysavač, podlahové topení, klimatizace, elektrické žaluzie a rolety, obklady a ozdobné prvky (kamenné obklady, pohledový beton, nerezové prvky, mozaiky). Dále obsahuje externí vybavení objektu: solární panely, nádrže na hospodaření s dešťovou vodou, provětrávané fasády (zelené, plechové, dřevěné), střechu (zelená, měděná, šindel, břidlice, pochozí, posuvná). ',
                        },
                    ],
                },
            ],
        }
    },
    watch: {
        'propertyTypeModel'() {
            let currentProp = this.propertyTypeModel;
            let propName = currentProp.split('-')[1];
            if (this.oldQuality === '') {
                this.reproductionQualityModel = 'reproduction-quality_' + propName + '_standard';
            } else {
                this.reproductionQualityModel = 'reproduction-quality_' + propName + '_' + this.oldQuality;
            }
        }
    },
    mounted() {
        if (this.oldQuality !== '') {
            let tempPropertyType = this.propertyTypeModel.replace('property_type-', '');
            this.reproductionQualityModel = 'reproduction-quality_' + tempPropertyType + '_' + this.oldQuality;
        }
    }
}
</script>
